import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './GroupParentDisplay.scss';
var renderAnswer = function renderAnswer(answer, index) {
  if (answer.value) {
    switch (answer.question_type) {
      case 'select_one':
        if (answer.style === 'multiselect') {
          return /*#__PURE__*/React.createElement("span", {
            key: "".concat(answer.question_type, "-field-").concat(index),
            className: "field-".concat(index, " ").concat(answer.question_type, " ").concat(answer.style)
          }, answer.question_key === 'languages_language_id' && /*#__PURE__*/React.createElement("i", {
            className: "fa fa-globe-americas"
          }), answer.value.label);
        }
        break;
      case 'freetext':
      case 'location':
      case 'year':
      case 'number':
        return /*#__PURE__*/React.createElement("span", {
          key: "".concat(answer.question_type, "-field-").concat(index),
          className: "field-".concat(index, " ").concat(answer.question_type, " ").concat(answer.style)
        }, answer.value);
      case 'date':
        return /*#__PURE__*/React.createElement("span", {
          key: "".concat(answer.question_type, "-field-").concat(index),
          className: "field-".concat(index, " ").concat(answer.question_type, " ").concat(answer.style)
        }, moment(answer.value).format('LL'));
      default:
        return null;
    }
  }
  return null;
};
function GroupParentDisplay(_ref) {
  var answers = _ref.answers,
    questionKey = _ref.questionKey;
  return /*#__PURE__*/React.createElement("div", {
    key: questionKey,
    className: "group-parents"
  }, answers.map(function (answer, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "group-parent-display-".concat(index),
      className: "group-parent-display group-parent-display-".concat(index, " ").concat(questionKey)
    }, answer.map(function (a, i) {
      return renderAnswer(a, i);
    }));
  }));
}
GroupParentDisplay.propTypes = {
  answers: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
  questionKey: PropTypes.string.isRequired
};
export default GroupParentDisplay;